export interface StatTableColumn {
  prop: string;
  translationKey: string;
  /** Rendered as-is instead of number-formatted. */
  text?: boolean;
}

const baseStats: StatTableColumn[] = [
  { prop: 'annualCO2Reduction', translationKey: 'annual-co2-reduction' },
  { prop: 'investment', translationKey: 'investment' },
  { prop: 'investmentReturn', translationKey: 'investment-return' },
  { prop: 'systemCapacity', translationKey: 'system-capacity' },
  // text: rendered as-is instead of number-formatted
  { prop: 'source', translationKey: 'source', text: true },
  { prop: 'time', translationKey: 'time' },
];

export const statTableConfig = {
  baseStats,
  // Add translation keys to template when new columns are added here
  basicColumns: [
    { prop: 'lat', translationKey: 'lat' },
    { prop: 'lng', translationKey: 'lng' },
    ...baseStats,
    { prop: 'omm', translationKey: 'omm', text: true },
    { prop: 'tariffGroup', translationKey: 'tariff-group', text: true },
  ],
};
